import React, { useState, useEffect } from "react";
import ROOT_URL from "../../Utilities/apiconfig";
import { Helmet } from "react-helmet";

const Footer = () => {
  const textColor = { color: "rgb(11, 8, 45)" };
  const [visitorCount, setVisitorCount] = useState(0);
  const [animatedCount, setAnimatedCount] = useState(0);

  useEffect(() => {
    fetch(`${ROOT_URL}/api/visitors/visit`)
      .then((response) => response.json())
      .then((data) => {
        setVisitorCount(data.count);
      })
      .catch((error) => console.error("Error fetching visitor count:", error));
  }, []);

  useEffect(() => {
    if (visitorCount > 0) {
      let count = 0;
      const increment = Math.ceil(visitorCount / 100);
      const interval = setInterval(() => {
        count += increment;
        if (count >= visitorCount) {
          setAnimatedCount(visitorCount);
          clearInterval(interval);
        } else {
          setAnimatedCount(count);
        }
      }, 20);

      return () => clearInterval(interval);
    }
  }, [visitorCount]);

  return (
    <div>
      <Helmet>
        <title>Columbiaa Hospital Contact | Best Multi-Speciality Hospital in Kasturi Nagar Bangalore</title>
        <meta name="description" content="Contact Columbiaa Hospital, the best multi-speciality hospital in Kasturi Nagar, Bangalore. Call 080 4448 4444 or email care@columbiaahospital.com. 24/7 emergency services, expert neurosurgeons, brain surgery, spine care, cardiology, orthopedics, dialysis, and ambulance services. Book appointments today." />
        <meta name="keywords" content="Columbiaa Hospital, hospital in Kasturi Nagar, hospital in Bangalore, best multi-speciality hospital, contact Columbiaa Hospital, Columbiaa Hospital phone number, Columbiaa Hospital email, Columbiaa Hospital address, hospital contact, hospital emergency, 24/7 hospital, emergency hospital Bangalore, appointment booking, neurosurgeon Bangalore, brain surgeon Bangalore, spine surgeon Bangalore, neuro hospital Bangalore, cardiology hospital, cardiac hospital Bangalore, orthopedics hospital, dialysis center, ICU hospital, ambulance service, healthcare Bangalore, medical treatment, specialist doctor, hospital near me, top hospital Bangalore, multi-speciality hospital near me, Kasturi Nagar hospital, OMBR Layout hospital" />
        <meta name="author" content="Columbiaa Hospital" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Columbiaa Hospital Contact | Best Multi-Speciality Hospital in Kasturi Nagar Bangalore" />
        <meta property="og:description" content="Contact Columbiaa Hospital, the best multi-speciality hospital in Kasturi Nagar, Bangalore. Call 080 4448 4444 or email care@columbiaahospital.com. 24/7 emergency services available." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://columbiaahospital.com/contacts" />
        <meta property="og:site_name" content="Columbiaa Hospital" />
        <meta property="og:locale" content="en_IN" />
        <link rel="canonical" href="https://columbiaahospital.com/contacts" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "MedicalOrganization",
              "name": "Columbiaa Hospital",
              "url": "https://columbiaahospital.com",
              "logo": "https://columbiaahospital.com/assets/images/zclogo.png",
              "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+91-8044484444",
                "contactType": "appointments",
                "areaServed": "IN",
                "availableLanguage": ["English", "Hindi", "Kannada"]
              },
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Building No 06, 5th Main Rd, B Channasandra, OMBR Layout",
                "addressLocality": "Bengaluru",
                "addressRegion": "Karnataka",
                "postalCode": "560043",
                "addressCountry": "IN"
              },
              "sameAs": [
                "https://www.facebook.com/share/1BFLVsneD2/",
                "https://x.com/columbiaahosp",
                "https://www.linkedin.com/in/columbiaa-hospital-kasturi-nagar-bengaluru-98aa37323/",
                "https://www.instagram.com/columbiaahospital/",
                "https://www.youtube.com/@columbiaahospital"
              ]
            }
          `}
        </script>
      </Helmet>
      
      <footer
        className="main-footer"
        style={{ backgroundColor: "rgb(63, 20, 0)", ...textColor }}
        role="contentinfo"
        aria-label="Footer - Columbiaa Hospital contact information and links"
      >
        <div
          className="pattern-layer"
          style={{ backgroundImage: "url(assets/images/shape/pattern-111.png)" }}
          aria-hidden="true"
        ></div>
        <div className="auto-container" data-aos="zoom-in">
          <div className="footer-top">
            <div className="widget-section">
              <div className="row clearfix">
                <div className="col-lg-4 col-md-6 col-sm-12 footer-column">
                  <div className="footer-widget about-widget">
                    <div className="widget-title">
                      <h3 style={textColor} aria-label="Hospital Address">Hospital Address</h3>
                    </div>
                    <div className="text">
                      <h2 style={textColor} aria-label="Columbiaa Hospital">Columbiaa Hospital</h2>
                      <p
                        style={textColor}
                        aria-label="Columbiaa Hospital contact details including address, email, and phone number"
                      >
                        Building No 06, 5th Main Rd, B Channasandra, OMBR
                        Layout, Kasturi Nagar, Bengaluru, Karnataka 560043
                        <br />
                        <a
                          href="mailto:care@columbiaahospital.com"
                          style={textColor}
                          title="Email Columbiaa Hospital"
                          aria-label="Email: care@columbiaahospital.com"
                        >
                          care@columbiaahospital.com
                        </a>
                        <br />
                        <a
                          href="tel:08044484444"
                          style={textColor}
                          aria-label="Call Columbiaa Hospital at 080 4448 4444"
                          title="Call Columbiaa Hospital at 080 4448 4444"
                        >
                          080 4448 4444
                        </a>
                      </p>
                    </div>
                    <h5 style={textColor} aria-label="Stay Connected">Stay Connected:</h5>

                    <ul className="social-links clearfix" role="list" aria-label="Social media links">
                      <li>
                        <a
                          href="https://www.facebook.com/columbiaahospital"
                          style={textColor}
                          target="_blank"
                          rel="noopener noreferrer"
                          title="Follow Columbiaa Hospital on Facebook"
                          aria-label="Columbiaa Hospital Facebook page"
                        >
                          <i
                            className="fab fa-facebook-f"
                            aria-hidden="true"
                          ></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://x.com/columbiaahosp"
                          style={{ fontWeight: "700", color: "rgb(11, 8, 45)" }}
                          target="_blank"
                          rel="noopener noreferrer"
                          title="Follow Columbiaa Hospital on X (formerly Twitter)"
                          aria-label="Columbiaa Hospital X (formerly Twitter) profile"
                        >
                          X
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.instagram.com/columbiaahospital/"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={textColor}
                          title="Follow Columbiaa Hospital on Instagram"
                          aria-label="Columbiaa Hospital Instagram profile"
                        >
                          <i className="fab fa-instagram" aria-hidden="true"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.youtube.com/@columbiaahospital"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={textColor}
                          title="Subscribe to Columbiaa Hospital on YouTube"
                          aria-label="Columbiaa Hospital YouTube Channel"
                        >
                          <i className="fab fa-youtube" aria-hidden="true"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-2 col-md-6 col-sm-12 footer-column">
                  <div className="footer-widget contact-widget">
                    <div className="single-info-box">
                      <div className="widget-title">
                        <h3 style={textColor} aria-label="Useful Links">Useful Links</h3>
                      </div>
                      <ul className="info-box clearfix " role="list" aria-label="Quick links to hospital sections">
                        <li className="py-1">
                          <a
                            href="/about-us"
                            title="About Columbiaa Hospital – Leading Healthcare in Bangalore"
                            aria-label="Learn About Columbiaa Hospital – Bangalore"
                            style={textColor}
                          >
                            About Us
                          </a>
                        </li>
                        <li className="py-1">
                          <a
                            href="/services"
                            title="Health and Medical Resources at Columbiaa Hospital Bangalore"
                            aria-label="Explore Resources – Columbiaa Hospital Bangalore"
                            style={textColor}
                          >
                            Resources
                          </a>
                        </li>
                        <li className="py-1">
                          <a
                            href="/services"
                            title="Explore Medical Services at Columbiaa Hospital Bangalore"
                            aria-label="Our Services – Columbiaa Hospital Bangalore"
                            style={textColor}
                          >
                            Our Services
                          </a>
                        </li>
                        <li className="py-1">
                          <a
                            href="/doctors"
                            title="Meet Experienced Doctors at Columbiaa Hospital Bangalore"
                            aria-label="Meet Our Doctors – Columbiaa Hospital Bangalore"
                            style={textColor}
                          >
                            Our Doctors
                          </a>
                        </li>
                        <li className="py-1">
                          <a
                            href="/services"
                            style={textColor}
                            title="Explore Medical Specialities at Columbiaa Hospital"
                            aria-label="Columbiaa Hospital Medical Specialities"
                          >
                            Our Specialities
                          </a>
                        </li>
                        <li className="py-1">
                          <a
                            href="/health-packages"
                            style={textColor}
                            title="Explore Health Checkup Packages at Columbiaa Hospital"
                            aria-label="Health Checkup Packages – Columbiaa Hospital"
                          >
                            Health Packages
                          </a>
                        </li>
                        <li className="py-1">
                          <a
                            href="/departments"
                            style={textColor}
                            title="Explore Departments at Columbiaa Hospital"
                            aria-label="Hospital Departments – Columbiaa Hospital"
                          >
                            Departments
                          </a>
                        </li>
                        <li className="py-1">
                          <a
                            href="/contacts"
                            style={textColor}
                            title="Get in Touch with Columbiaa Hospital"
                            aria-label="Contact Columbiaa Hospital"
                          >
                            Contact Us
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12 footer-column">
                  <div className="footer-widget contact-widget">
                    <div className="single-info-box">
                      <div className="widget-title">
                        <h3 style={textColor} aria-label="For Appointments">For Appointments</h3>
                      </div>
                      <ul className="info-box clearfix" role="list" aria-label="Appointment contact numbers">
                        <li>
                          <a
                            href="tel:08044484444"
                            style={textColor}
                            aria-label="Call Columbiaa Hospital at 080 4448 4444"
                            title="Call Columbiaa Hospital at 080 4448 4444"
                          >
                            080 44484444
                          </a>
                        </li>
                        <li>
                          <a
                            href="tel:08040939899"
                            style={textColor}
                            aria-label="Call Columbiaa Hospital at 080 4093 9899"
                            title="Call Columbiaa Hospital at 080 4093 9899"
                          >
                            080 40939899
                          </a>
                        </li>
                        <li>
                          <a
                            href="mailto:info@columbiaahospital.com"
                            style={textColor}
                            aria-label="Email Columbiaa Hospital at info@columbiaahospital.com"
                            title="Email Columbiaa Hospital at info@columbiaahospital.com"
                          >
                            info@columbiaahospital.com
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div className="single-info-box">
                      <div className="widget-title">
                        <h3 style={textColor} aria-label="Emergency Contact">Emergency:</h3>
                      </div>
                      <ul className="info-box clearfix" role="list" aria-label="Emergency contact information">
                        <li>
                          <a
                            href="tel:8548979899"
                            style={textColor}
                            aria-label="Call Columbiaa Hospital emergency at plus nine one eight five four eight nine seven nine eight nine nine"
                            title="Call Columbiaa Hospital at (+91) 8548979899"
                          >
                            (+91) 8548979899
                          </a>
                        </li>
                        <li>
                          <a
                            href="mailto:care@columbiaahospital.com"
                            style={textColor}
                            aria-label="Email care department at Columbiaa Hospital"
                            title="Email care@columbiaahospital.com"
                          >
                            care@columbiaahospital.com
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12 footer-column">
                  <div className="footer-widget contact-widget">
                    <div className="single-info-box">
                      <div className="widget-title">
                        <h3 style={textColor} aria-label="Find on Google Maps">Find on Google Maps</h3>
                      </div>
                      <ul className="info-box clearfix" role="group" aria-label="Columbiaa Hospital location map">
                        <iframe
                          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d119537.43538739184!2d77.5758730442529!3d13.010418302574193!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae1707efe7bf55%3A0x9a2782fbc38e9c7b!2sColumbiaa%20Hospital!5e1!3m2!1sen!2sin!4v1740473493668!5m2!1sen!2sin"
                          width="100%"
                          height="300"
                          title="Columbiaa Hospital Location Map - Find us on Google Maps"
                          allowFullScreen=""
                          loading="lazy"
                          referrerPolicy="no-referrer-when-downgrade"
                          aria-label="Interactive map showing Columbiaa Hospital location in Kasturi Nagar, Bangalore"
                        ></iframe>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-bottom clearfix">
            <div className="copyright pull-left">
              <p style={textColor}>
                &copy; 2026{" "}
                <a
                  href="/"
                  style={textColor}
                  title="Columbiaa Hospital Homepage"
                  aria-label="Visit Columbiaa Hospital Homepage"
                >
                  Columbiaa Hospital
                </a>
                , All Rights Reserved
              </p>
            </div>
            <ul className="footer-nav pull-right clearfix" role="list" aria-label="Footer navigation links">
              <li>
                <a
                  href="/POSH-policy.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={textColor}
                  title="View POSH (Prevention of Sexual Harassment) Policy"
                  aria-label="View POSH Policy in PDF format"
                >
                  POSH Policy
                </a>
              </li>
              <li>
                <a
                  href="#"
                  style={textColor}
                  title="Terms and Conditions for Columbiaa Hospital services"
                  aria-label="Terms and Conditions"
                >
                  Terms & Conditions
                </a>
              </li>
            </ul>
          </div>
        </div>
      </footer>
      <section
        className="doctor-header text-center py-3 px-3"
        style={{ backgroundColor: "#1e1c42", color: "#fff" }}
        aria-label="Website visitor statistics"
      >
        <h4
          style={{ fontSize: "24px", fontWeight: "normal", color: "#fff" }}
          aria-label={`Total visitors to our website: ${animatedCount}`}
        >
          Total Visitors to Our Website : {animatedCount}
        </h4>
      </section>
    </div>
  );
};

export default Footer;
